import React, { useState, useEffect } from 'react';
import '.././styles/reports/ancform.css';
import { showSuccess, showError } from '../utils/alert';
import { useNavigate } from 'react-router-dom';
import { createAncVisit , getPregnancyTrackingData} from '../services/authService';
import { useSelector } from 'react-redux';
const ANCVisitForm = () => {
  // State to hold form data
  const initialFormState = {
    pregnancy_id: '',
    beneficiary_id: '',
    visit_number: '',
    visit_date: new Date().toISOString().split('T')[0],
    gestational_age: '',
    weight: '',
    blood_pressure_systolic: '',
    blood_pressure_diastolic: '',
    fundal_height: '',
    fetal_heart_rate: '',
    hemoglobin: '',
    urine_protein: '',
    urine_sugar: '',
    edema: 'None',
    iron_folic_acid_given: false,
    tetanus_toxoid_given: false,
    calcium_tablets: false,
    deworming_tablet: false,
    danger_signs: [],
    advice_given: [],
    visit_location: '',
    next_visit_date: '',
    next_visit_location: '',
    referral: 'no',
    referred_to: '',
    reason_for_referral: '',
    notes: '',
    conducted_by: localStorage.getItem('asha_id') || '',
  };

  const [formData, setFormData] = useState(initialFormState);
  const [pregnancyList, setPregnancyList] = useState([]);
  const [selectedPregnancy, setSelectedPregnancy] = useState(null);
  const [showPregnancyForm, setShowPregnancyForm] = useState(false);
  const navigate = useNavigate();
  const selectedVillageId = useSelector((state) => state.village.selectedVillageId);
  // Fetch pregnancy tracking data on mount
  useEffect(() => {
    async function fetchPregnancyTrackingData() {
      try {
        const asha_id = localStorage.getItem('asha_id');
        const response = await getPregnancyTrackingData();

        if (response.status === true && response.status === true) {
          showSuccess(response.message || 'Pregnancy tracking data fetched successfully!');
          const formattedList = response.data.map(p => ({
            tracking_id: p.tracking_id,
            beneficiary_id: p.beneficiary_id,
            beneficiary_name: p['Beneficiary.name'],
            age: p['Beneficiary.age'],
            gender: p['Beneficiary.gender'],
            village_name: p['Beneficiary.Village.village_name'],
            edd: p.edd,
            anc_visit_count: p.anc_visit_count,
            lmp_date: p.lmp_date,
            risk_status: p.risk_status,
           anc_visit: {
            weight: p['AncVisits.weight'] || '',
            blood_pressure_systolic: p['AncVisits.blood_pressure_systolic'] || '',
            blood_pressure_diastolic: p['AncVisits.blood_pressure_diastolic'] || '',
            fundal_height: p['AncVisits.fundal_height'] || '',
            fetal_heart_rate: p['AncVisits.fetal_heart_rate'] || '',
            hemoglobin: p['AncVisits.hemoglobin'] || '',
            urine_protein: p['AncVisits.urine_protein'] || '',
            urine_sugar: p['AncVisits.urine_sugar'] || '',
            edema: p['AncVisits.edema'] || 'None',
            gestational_age: p['AncVisits.gestational_age'] || '',
          }
          }));  
          setPregnancyList(formattedList);

          if (formattedList.length > 0) {
              console.log('defaultPregnancy', formattedList);
            const defaultPregnancy = formattedList[0];
          
            setSelectedPregnancy(defaultPregnancy);
            setFormData((prev) => ({
              ...prev,
              pregnancy_id: defaultPregnancy.tracking_id,
              beneficiary_id: defaultPregnancy.beneficiary_id,
              visit_number: (defaultPregnancy.anc_visit_count + 1).toString(),
              gestational_age: defaultPregnancy.anc_visit.gestational_age || calculateGestationalAge(defaultPregnancy.lmp_date),
              weight: defaultPregnancy.anc_visit.weight,
              blood_pressure_systolic: defaultPregnancy.anc_visit.blood_pressure_systolic,
              blood_pressure_diastolic: defaultPregnancy.anc_visit.blood_pressure_diastolic,
              fundal_height: defaultPregnancy.anc_visit.fundal_height,
              fetal_heart_rate: defaultPregnancy.anc_visit.fetal_heart_rate,
              hemoglobin: defaultPregnancy.anc_visit.hemoglobin,
              urine_protein: defaultPregnancy.anc_visit.urine_protein,
              urine_sugar: defaultPregnancy.anc_visit.urine_sugar,
              edema: defaultPregnancy.anc_visit.edema,
            }));
          }
        } else {
          showError(response.message || 'No pregnancy tracking data found');
        }
      } catch (err) {
        showError('Network error while fetching pregnancy tracking data');
        console.error('Fetch error:', err);
      }
    }

    fetchPregnancyTrackingData();
  }, [selectedVillageId]);

  // Calculate gestational age based on LMP
  const calculateGestationalAge = (lmpDate) => {
    if (!lmpDate) return '';
    const lmp = new Date(lmpDate);
    const today = new Date();
    const gestationalAgeWeeks = Math.floor((today - lmp) / (1000 * 60 * 60 * 24 * 7));
    return gestationalAgeWeeks > 0 ? gestationalAgeWeeks.toString() : '';
  };

  // Handle pregnancy selection
  const handlePregnancyChange = (e) => {
    const selected = pregnancyList.find(p => p.tracking_id === parseInt(e.target.value));
    if (selected) {
      setSelectedPregnancy(selected);
      setFormData((prev) => ({
        ...prev,
        pregnancy_id: selected.tracking_id,
        beneficiary_id: selected.beneficiary_id,
        visit_number: (selected.anc_visit_count + 1).toString(),
        gestational_age: selected.anc_visit.gestational_age || calculateGestationalAge(selected.lmp_date),
        weight: selected.anc_visit.weight,
        blood_pressure_systolic: selected.anc_visit.blood_pressure_systolic,
        blood_pressure_diastolic: selected.anc_visit.blood_pressure_diastolic,
        fundal_height: selected.anc_visit.fundal_height,
        fetal_heart_rate: selected.anc_visit.fetal_heart_rate,
        hemoglobin: selected.anc_visit.hemoglobin,
        urine_protein: selected.anc_visit.urine_protein,
        urine_sugar: selected.anc_visit.urine_sugar,
        edema: selected.anc_visit.edema,
      }));
      setShowPregnancyForm(false);
    }
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Handle multi-select chips (e.g., danger signs, counseling)
  const handleChipToggle = (field, value) => {
    setFormData((prev) => {
      const currentValues = prev[field] || [];
      if (currentValues.includes(value)) {
        return { ...prev, [field]: currentValues.filter((item) => item !== value) };
      } else {
        return { ...prev, [field]: [...currentValues, value] };
      }
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.pregnancy_id || !formData.visit_number || !formData.visit_date) {
      showError('Please select a pregnancy and fill required fields: Visit Number, Visit Date.');
      return;
    }

    const dataToSave = {
      pregnancy_id: parseInt(formData.pregnancy_id),
      visit_number: parseInt(formData.visit_number),
      visit_date: formData.visit_date,
      gestational_age: parseInt(formData.gestational_age) || null,
      weight: parseFloat(formData.weight) || null,
      blood_pressure_systolic: parseInt(formData.blood_pressure_systolic) || null,
      blood_pressure_diastolic: parseInt(formData.blood_pressure_diastolic) || null,
      fundal_height: parseFloat(formData.fundal_height) || null,
      fetal_heart_rate: parseInt(formData.fetal_heart_rate) || null,
      hemoglobin: parseFloat(formData.hemoglobin) || null,
      urine_protein: formData.urine_protein || null,
      urine_sugar: formData.urine_sugar || null,
      edema: formData.edema,
      iron_folic_acid_given: formData.iron_folic_acid_given,
      tetanus_toxoid_given: formData.tetanus_toxoid_given,
      danger_signs: formData.danger_signs.join(', ') || null,
      advice_given: formData.advice_given.join(', ') || null,
      next_visit_date: formData.next_visit_date || null,
      conducted_by: parseInt(formData.conducted_by),
      visit_location: formData.visit_location || null,
      next_visit_location: formData.next_visit_location || null,
      referral: formData.referral === 'yes' ? true : false,
      referred_to: formData.referral === 'yes' ? formData.referred_to : null,
      reason_for_referral: formData.referral === 'yes' ? formData.reason_for_referral : null,
      notes: formData.notes || null,
    };

    if (!navigator.onLine) {
      // Save to localStorage
      const offlineData = JSON.parse(localStorage.getItem('offlineAncVisits') || '[]');
      offlineData.push(dataToSave);
      localStorage.setItem('offlineAncVisits', JSON.stringify(offlineData));
      showSuccess('Saved offline. Data will sync when online.');
      return;
    }

    try {
      const response = await createAncVisit(dataToSave);
      if (response.status === true) {
        showSuccess(response.message);
        navigate('/anc');
      } else {
        showError(response.message || 'Failed to save ANC Visit');
      }
    } catch (err) {
      showError('Network error or something went wrong');
      console.error('Submission error:', err);
    }
  };

  // Sync offline data when online
  useEffect(() => {
    const syncOfflineData = async () => {
      if (navigator.onLine) {
        const offlineData = JSON.parse(localStorage.getItem('offlineAncVisits') || '[]');
        if (offlineData.length > 0) {
          for (const data of offlineData) {
            try {
              await createAncVisit(data);
            } catch (error) {
              console.error('Error syncing data:', error);
            }
          }
          localStorage.removeItem('offlineAncVisits');
          showSuccess('Offline data synced successfully!');
        }
      }
    };

    window.addEventListener('online', syncOfflineData);
    return () => window.removeEventListener('online', syncOfflineData);
  }, []);

  return (
    <>
      <div className="page-header">
        <button className="back-button" onClick={() => navigate('/anc')}>
          <span className="material-icons">arrow_back</span>
        </button>
        <div className="page-title">New ANC Visit</div>
      </div>


      <form className="form-card" onSubmit={handleSubmit}>
        {/* Progress Indicator */}
        <div className="progress-indicator">
          {[1, 2, 3, 4].map((num) => (
            <React.Fragment key={num}>
              <div className="progress-step">
                <div
                  className={`step-circle ${
                    parseInt(formData.visit_number) === num
                      ? 'active'
                      : parseInt(formData.visit_number) > num
                      ? 'completed'
                      : ''
                  }`}
                >
                  {parseInt(formData.visit_number) > num ? (
                    <span className="material-icons" style={{ fontSize: '16px' }}>
                      check
                    </span>
                  ) : (
                    num
                  )}
                </div>
                <div
                  className={`step-label ${
                    parseInt(formData.visit_number) === num ? 'active' : ''
                  }`}
                >
                  {num}th Visit
                </div>
              </div>
              {num < 4 && <div className="step-connector"></div>}
            </React.Fragment>
          ))}
        </div>

        {/* Pregnant Woman Section */}
        <div className="form-section">
          <div className="section-title">Pregnant Woman</div>
          {selectedPregnancy && (
            <div className="beneficiary-card">
              <div className="beneficiary-info">
                <div className="beneficiary-name">
                  {selectedPregnancy.beneficiary_name}{' '}
                  <span className="risk-tag">{selectedPregnancy.risk_status.replace('_', ' ')}</span>
                </div>
                <div className="beneficiary-details">
                  {selectedPregnancy.age} years • {selectedPregnancy.gender} • EDD:{' '}
                  {new Date(selectedPregnancy.edd).toLocaleDateString()}
                </div>
                <div className="beneficiary-village">{selectedPregnancy.village_name}</div>
              </div>
              <button
                type="button"
                className="change-button"
                onClick={() => setShowPregnancyForm(!showPregnancyForm)}
              >
                Change
              </button>
            </div>
          )}

          {showPregnancyForm && (
            <div className="form-field">
              <label className="label">Select Pregnancy</label>
              <select
                className="input-field"
                onChange={handlePregnancyChange}
                value={selectedPregnancy?.tracking_id || ''}
              >
                <option value="" disabled>Select pregnancy...</option>
                {pregnancyList.map((p) => (
                  <option key={p.tracking_id} value={p.tracking_id}>
                    {p.beneficiary_name} - EDD: {new Date(p.edd).toLocaleDateString()} -{' '}
                    {p.village_name}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="divider"></div>

        {/* Visit Details */}
        <div className="form-section">
          <div className="section-title">Visit Details</div>
          <div className="form-row">
            <div className="form-field">
              <label className="label">Visit Date</label>
              <input
                type="date"
                name="visit_date"
                className="date-picker"
                value={formData.visit_date}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-field">
              <label className="label">Visit Number</label>
              <select
                name="visit_number"
                className="input-field"
                value={formData.visit_number}
                onChange={handleInputChange}
              >
                <option value="1">1st ANC Visit</option>
                <option value="2">2nd ANC Visit</option>
                <option value="3">3rd ANC Visit</option>
                <option value="4">4th ANC Visit</option>
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field">
              <label className="label">Gestational Age (weeks)</label>
              <input
                type="number"
                name="gestational_age"
                className="input-field"
                value={formData.gestational_age}
                onChange={handleInputChange}
                min="1"
                max="45"
              />
            </div>
            <div className="form-field">
              <label className="label">Visit Location</label>
              <select
                name="visit_location"
                className="input-field"
                value={formData.visit_location}
                onChange={handleInputChange}
              >
                <option value="">Select location</option>
                <option value="Home">Home</option>
                <option value="Anganwadi Center">Anganwadi Center</option>
                <option value="Health Center">Health Center</option>
                <option value="Village Clinic">Village Clinic</option>
              </select>
            </div>
          </div>
        </div>

        <div className="divider"></div>

        {/* Vitals */}
        <div className="form-section">
          <div className="section-title">Vitals</div>
          <div className="form-row">
            <div className="form-field">
              <label className="label">Weight (kg)</label>
              <input
                type="number"
                name="weight"
                className="input-field"
                value={formData.weight}
                onChange={handleInputChange}
                step="0.1"
              />
            </div>
            <div className="form-field">
              <label className="label">Blood Pressure (mmHg)</label>
              <div style={{ display: 'flex', gap: '8px' }}>
                <input
                  type="number"
                  name="blood_pressure_systolic"
                  className="input-field"
                  value={formData.blood_pressure_systolic}
                  onChange={handleInputChange}
                  placeholder="Systolic"
                />
                <input
                  type="number"
                  name="blood_pressure_diastolic"
                  className="input-field"
                  value={formData.blood_pressure_diastolic}
                  onChange={handleInputChange}
                  placeholder="Diastolic"
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field">
              <label className="label">Hemoglobin (g/dL)</label>
              <input
                type="number"
                name="hemoglobin"
                className="input-field"
                value={formData.hemoglobin}
                onChange={handleInputChange}
                step="0.1"
              />
            </div>
            <div className="form-field">
              <label className="label">Fundal Height (cm)</label>
              <input
                type="number"
                name="fundal_height"
                className="input-field"
                value={formData.fundal_height}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field">
              <label className="label">Fetal Heart Rate (bpm)</label>
              <input
                type="number"
                name="fetal_heart_rate"
                className="input-field"
                value={formData.fetal_heart_rate}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-field">
              <label className="label">Urine Protein</label>
              <select
                name="urine_protein"
                className="input-field"
                value={formData.urine_protein}
                onChange={handleInputChange}
              >
                <option value="">Not Done</option>
                <option value="negative">Negative</option>
                <option value="trace">Trace</option>
                <option value="1+">1+</option>
                <option value="2+">2+</option>
                <option value="3+">3+</option>
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field">
              <label className="label">Urine Sugar</label>
              <select
                name="urine_sugar"
                className="input-field"
                value={formData.urine_sugar}
                onChange={handleInputChange}
              >
                <option value="">Not Done</option>
                <option value="negative">Negative</option>
                <option value="trace">Trace</option>
                <option value="1+">1+</option>
                <option value="2+">2+</option>
                <option value="3+">3+</option>
              </select>
            </div>
            <div className="form-field">
              <label className="label">Edema</label>
              <select
                name="edema"
                className="input-field"
                value={formData.edema}
                onChange={handleInputChange}
              >
                <option value="None">None</option>
                <option value="Mild">Mild</option>
                <option value="Moderate">Moderate</option>
                <option value="Severe">Severe</option>
              </select>
            </div>
          </div>
        </div>

        <div className="divider"></div>

        {/* Danger Signs */}
        <div className="form-section">
          <div className="section-title">Danger Signs Check</div>
          <div className="section-subtitle">Select all that apply</div>
          <div className="chip-container">
            {[
              'High BP',
              'Vaginal Bleeding',
              'Severe Headache',
              'Visual Disturbance',
              'Abdominal Pain',
              'Swelling of Face/Hands',
              'Reduced Fetal Movement',
              'Fever',
            ].map((sign) => (
              <div
                key={sign}
                className={`chip ${formData.danger_signs.includes(sign) ? 'selected' : ''}`}
                onClick={() => handleChipToggle('danger_signs', sign)}
              >
                {sign}
              </div>
            ))}
          </div>
        </div>

        <div className="divider"></div>

        {/* Supplements & Vaccines */}
        <div className="form-section">
          <div className="section-title">Supplements & Vaccines</div>
          <div className="checkbox-option">
            <input
              type="checkbox"
              name="iron_folic_acid_given"
              checked={formData.iron_folic_acid_given}
              onChange={handleInputChange}
            />
            <label>IFA tablets provided (Count: 30)</label>
          </div>
          <div className="checkbox-option">
            <input
              type="checkbox"
              name="calcium_tablets"
              checked={formData.calcium_tablets}
              onChange={handleInputChange}
            />
            <label>Calcium tablets provided (Count: 30)</label>
          </div>
          <div className="checkbox-option">
            <input
              type="checkbox"
              name="deworming_tablet"
              checked={formData.deworming_tablet}
              onChange={handleInputChange}
            />
            <label>Deworming tablet provided</label>
          </div>
          <div className="checkbox-option">
            <input
              type="checkbox"
              name="tetanus_toxoid_given"
              checked={formData.tetanus_toxoid_given}
              onChange={handleInputChange}
            />
            <label>TT2 vaccination given</label>
          </div>
        </div>

        <div className="divider"></div>

        {/* Counseling Provided */}
        <div className="form-section">
          <div className="section-title">Counseling Provided</div>
          <div className="section-subtitle">Select all that apply</div>
          <div className="chip-container">
            {[
              'Nutrition',
              'Rest & Sleep',
              'Danger Signs',
              'Birth Preparedness',
              'Institutional Delivery',
              'Breastfeeding',
              'Family Planning',
            ].map((advice) => (
              <div
                key={advice}
                className={`chip ${formData.advice_given.includes(advice) ? 'selected' : ''}`}
                onClick={() => handleChipToggle('advice_given', advice)}
              >
                {advice}
              </div>
            ))}
          </div>
        </div>

        <div className="divider"></div>

        {/* Referral */}
        <div className="form-section">
          <div className="section-title">Referral</div>
          <div className="radio-group">
            <label className={`radio-option ${formData.referral === 'yes' ? 'selected' : ''}`}>
              <input
                type="radio"
                name="referral"
                value="yes"
                checked={formData.referral === 'yes'}
                onChange={handleInputChange}
              />
              Referred
            </label>
            <label className={`radio-option ${formData.referral === 'no' ? 'selected' : ''}`}>
              <input
                type="radio"
                name="referral"
                value="no"
                checked={formData.referral === 'no'}
                onChange={handleInputChange}
              />
              Not Referred
            </label>
          </div>
          {formData.referral === 'yes' && (
            <div className="form-row">
              <div className="form-field">
                <label className="label">Referred To</label>
                <select
                  name="referred_to"
                  className="input-field"
                  value={formData.referred_to}
                  onChange={handleInputChange}
                >
                  <option value="">Select referral destination</option>
                  <option value="Sub Center">Sub Center</option>
                  <option value="Primary Health Center">Primary Health Center</option>
                  <option value="Community Health Center">Community Health Center</option>
                  <option value="District Hospital">District Hospital</option>
                </select>
              </div>
              <div className="form-field">
                <label className="label">Reason for Referral</label>
                <select
                  name="reason_for_referral"
                  className="input-field"
                  value={formData.reason_for_referral}
                  onChange={handleInputChange}
                >
                  <option value="">Select reason</option>
                  <option value="Routine Checkup">Routine Checkup</option>
                  <option value="High Blood Pressure">High Blood Pressure</option>
                  <option value="Anemia">Anemia</option>
                  <option value="Abnormal Position">Abnormal Position</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
          )}
        </div>

        <div className="divider"></div>

        {/* Next Visit */}
        <div className="form-section">
          <div className="section-title">Next Visit</div>
          <div className="form-row">
            <div className="form-field">
              <label className="label">Next Visit Date</label>
              <input
                type="date"
                name="next_visit_date"
                className="date-picker"
                value={formData.next_visit_date}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-field">
              <label className="label">Location</label>
              <select
                name="next_visit_location"
                className="input-field"
                value={formData.next_visit_location}
                onChange={handleInputChange}
              >
                <option value="">Select location</option>
                <option value="Home">Home</option>
                <option value="Anganwadi Center">Anganwadi Center</option>
                <option value="Health Center">Health Center</option>
                <option value="Village Clinic">Village Clinic</option>
              </select>
            </div>
          </div>
        </div>

        <div className="divider"></div>

        {/* Notes */}
        <div className="form-section">
          <div className="section-title">Notes</div>
          <textarea
            name="notes"
            className="text-area"
            value={formData.notes}
            onChange={handleInputChange}
            placeholder="Additional notes..."
          />
        </div>

        <div className="action-buttons">
          <button
            type="button"
            className="cancel-button"
            onClick={() => navigate('/anc')}
          >
            Cancel
          </button>
          <button type="submit" className="save-button">
            <span className="material-icons icon">save</span>
            Save
          </button>
        </div>
      </form>
    </>
  );
};

export default ANCVisitForm;  